var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tileconf-container" },
    [
      _c("div", { staticClass: "switches-title switches-title-level1" }, [
        _c("div", { staticClass: "circle-number" }, [_vm._v("1")]),
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("genral_cos_please_config_switch")) +
            "\n    "
        ),
      ]),
      _c(
        "div",
        { staticClass: "switches" },
        _vm._l(_vm.siteMenuList, function (v, k) {
          return _c("div", { key: k, staticClass: "switch-item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t(v.menuCode))),
            ]),
            _c(
              "div",
              { staticClass: "switch" },
              [
                _c("el-switch", {
                  attrs: { size: "mini", disabled: v.disable },
                  on: {
                    change: function ($event) {
                      return _vm.onSiteMenuListSwitchChange(v)
                    },
                  },
                  model: {
                    value: v.checked,
                    callback: function ($$v) {
                      _vm.$set(v, "checked", $$v)
                    },
                    expression: "v.checked",
                  },
                }),
                v.menuCode === "client007"
                  ? _c(
                      "guidance-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("groupReportingTip"),
                          backgroundColor: "none",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "#fd349c" },
                          attrs: { slot: "icon" },
                          slot: "icon",
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "dashed-divide" }),
      _c("div", { staticClass: "switches-title switches-title-level1" }, [
        _c("div", { staticClass: "circle-number" }, [_vm._v("2")]),
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("genral_cos_please_config_tiles")) +
            "\n    "
        ),
      ]),
      _c(
        "el-collapse",
        { staticClass: "collapse" },
        [
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pbcOn,
                  expression: "pbcOn",
                },
              ],
              attrs: { name: "1" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "blue-border-title disable_select",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("config_pbc_tile")) +
                      "\n            "
                  ),
                ]
              ),
              _c("div", { staticClass: "collapse-container" }, [
                _c("div", { staticClass: "switches-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("general_tiles_interim_audit_switch")) +
                      "\n                "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "switch" },
                  [
                    _c("el-switch", {
                      attrs: {
                        size: "mini",
                        "active-text": _vm.$t("COMMON_YES"),
                        "inactive-text": _vm.$t("COMMON_NO"),
                      },
                      on: { change: _vm.onHasInterimChange },
                      model: {
                        value: _vm.hasInterim,
                        callback: function ($$v) {
                          _vm.hasInterim = $$v
                        },
                        expression: "hasInterim",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.vatOn,
                  expression: "vatOn",
                },
              ],
              attrs: { name: "8" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "blue-border-title disable_select",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("client008")) +
                      "\n            "
                  ),
                ]
              ),
              _c("div", { staticClass: "collapse-container" }, [
                _c("div", { staticClass: "switches-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("general_tiles_vat_audit_switch")) +
                      "\n                "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "switch" },
                  [
                    _c("el-switch", {
                      attrs: {
                        size: "mini",
                        "active-text": _vm.$t("COMMON_YES"),
                        "inactive-text": _vm.$t("COMMON_NO"),
                      },
                      on: { change: _vm.onHasVatChange },
                      model: {
                        value: _vm.showVatInformation,
                        callback: function ($$v) {
                          _vm.showVatInformation = $$v
                        },
                        expression: "showVatInformation",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.SASOn,
                  expression: "SASOn",
                },
              ],
              attrs: { name: "3" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "blue-border-title disable_select",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("config_Statutory_milestone")) +
                      "\n            "
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "collapse-container collapse-container-3" },
                [
                  _c("div", { staticClass: "milestone-title-tip" }, [
                    _c("i", { staticClass: "el-icon-warning" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("milestone_title_tip")) +
                        "\n                "
                    ),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      staticClass: "milestone-tabs",
                      attrs: {
                        type: "card",
                        addable: "",
                        "before-leave": _vm.beforeMilestoneTabLeave,
                      },
                      model: {
                        value: _vm.milestone.activeTab,
                        callback: function ($$v) {
                          _vm.$set(_vm.milestone, "activeTab", $$v)
                        },
                        expression: "milestone.activeTab",
                      },
                    },
                    [
                      _vm._l(_vm.milestone.list, function (v, k) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: k,
                            attrs: { name: `${k}` },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "tab-label" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tab-label-text" },
                                            [_vm._v(_vm._s(v.milestoneName))]
                                          ),
                                          _c(
                                            "el-dropdown",
                                            {
                                              staticClass: "tab-label-dropdown",
                                              on: {
                                                command: (e) =>
                                                  _vm.onLevelMilestoneDropClick(
                                                    e,
                                                    v,
                                                    k
                                                  ),
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-dropdown-link",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-more",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-menu",
                                                {
                                                  attrs: { slot: "dropdown" },
                                                  slot: "dropdown",
                                                },
                                                [
                                                  _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "left",
                                                        disabled:
                                                          v.editable === "0" ||
                                                          (k > 0 &&
                                                            _vm.milestone.list[
                                                              k - 1
                                                            ].childMilestoneBO.some(
                                                              (val) =>
                                                                val.editable ===
                                                                "0"
                                                            )),
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-back",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("move_left")
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "right",
                                                        disabled:
                                                          v.editable === "0",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-right",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("move_right")
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "rename",
                                                        disabled:
                                                          v.editable === "0",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-edit",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("rename")
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "delete",
                                                        disabled:
                                                          v.editable === "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          style: {
                                                            color:
                                                              v.editable === "0"
                                                                ? "#bbbbbb"
                                                                : "red",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "COMMON_DELETE"
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "milestone-table",
                                attrs: {
                                  data: v.childMilestoneBO,
                                  border: "",
                                  stripe: "",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "table_column_lable_milestone"
                                    ),
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form",
                                              {
                                                ref: `${scope.row.id}_milestoneName`,
                                                refInFor: true,
                                                attrs: {
                                                  model: scope.row,
                                                  rules: _vm.milestoneFormRule,
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop: "milestoneName",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        size: "mini",
                                                        disabled:
                                                          scope.row.editable ===
                                                          "0",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onMilestoneNameChange,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .milestoneName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "milestoneName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.milestoneName",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "table_column_lable_deadline"
                                    ),
                                    align: "center",
                                    width: "200",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-switch", {
                                              attrs: {
                                                size: "mini",
                                                "active-value": 1,
                                                "inactive-value": 0,
                                                disabled:
                                                  scope.row.editable === "0",
                                                "inactive-color": "#a9acaf",
                                              },
                                              on: {
                                                change: _vm.onTargetTimeChange,
                                              },
                                              model: {
                                                value:
                                                  scope.row.targetTimeSelected,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "targetTimeSelected",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.targetTimeSelected",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("table_column_lable_remarks"),
                                    align: "center",
                                    width: "200",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                size: "mini",
                                                disabled:
                                                  scope.row.editable === "0",
                                              },
                                              on: {
                                                change: _vm.onRemarkChange,
                                              },
                                              model: {
                                                value: scope.row.remark,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "remark",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.remark",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "table_column_lable_client_show"
                                    ),
                                    align: "center",
                                    width: "200",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-switch", {
                                              attrs: {
                                                size: "mini",
                                                "active-value": 1,
                                                "inactive-value": 0,
                                                disabled:
                                                  scope.row.editable === "0",
                                                "inactive-color": "#a9acaf",
                                              },
                                              on: {
                                                change: _vm.onAccessFlagChange,
                                              },
                                              model: {
                                                value: scope.row.accessFlag,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "accessFlag",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.accessFlag",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("table_column_lable_action"),
                                    width: "170",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ row, $index }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "table-actions" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "table-action",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-top",
                                                        $index == 0 ||
                                                        row.editable === "0" ||
                                                        _vm.milestone.list[k]
                                                          .childMilestoneBO[
                                                          $index - 1
                                                        ].editable === "0"
                                                          ? "table-action-disable"
                                                          : "",
                                                      ],
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.milestoneUp(
                                                            $index,
                                                            k,
                                                            row
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "table-action",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-bottom",
                                                        $index ==
                                                          v.childMilestoneBO
                                                            .length -
                                                            1 ||
                                                        row.editable === "0"
                                                          ? "table-action-disable"
                                                          : "",
                                                      ],
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.milestoneDown(
                                                            $index,
                                                            k,
                                                            row
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "table-action",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-delete",
                                                        "wl-icon-delete",
                                                        row.editable === "0"
                                                          ? "table-action-disable"
                                                          : "",
                                                      ],
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.milestoneDel(
                                                            v.id,
                                                            row.id,
                                                            row
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-tab-pane",
                        { attrs: { name: "milestone-add", closable: false } },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "label" },
                              on: { click: _vm.onAddLevel1MilestoneClick },
                              slot: "label",
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" " + _vm._s(_vm.$t("btn_add"))),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "add-milestone-btn" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: { size: "mini" },
                          on: { click: _vm.onAddMilestoneClick },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("add_milestone")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.milestone.deleteConfirm.show,
                        width: "300px",
                      },
                      on: {
                        "update:visible": function ($event) {
                          return _vm.$set(
                            _vm.milestone.deleteConfirm,
                            "show",
                            $event
                          )
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("dialog_title_warning")) +
                                  "\n                    "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      [
                        _c("div", { staticClass: "delete-confirm-container" }, [
                          _c("div", { staticClass: "delete-confirm-body" }, [
                            _c("i", {
                              staticClass: "el-icon-warning",
                              staticStyle: { color: "#ee7200" },
                            }),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("confirm_delete_milestone"))
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "delete-confirm-footer" },
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.deleteConfirmCancel } },
                                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "wl-green",
                                  on: { click: _vm.deleteConfirmConfirm },
                                },
                                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                    ],
                    2
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: { visible: _vm.milestone.add.show },
                      on: {
                        "update:visible": function ($event) {
                          return _vm.$set(_vm.milestone.add, "show", $event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.milestone.add.index > -1
                                      ? _vm.$t("rename_milestone")
                                      : _vm.$t("add_milestone")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      [
                        _c(
                          "div",
                          { staticClass: "delete-confirm-container" },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "level1MilestoneAdd",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  model: _vm.milestone.add,
                                  rules: _vm.milestoneFormRule,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "delete-confirm-body",
                                    attrs: {
                                      prop: "value",
                                      label: _vm.$t(
                                        "please_input_milestone_name"
                                      ),
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { size: "mini" },
                                      model: {
                                        value: _vm.milestone.add.value,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.milestone.add,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "milestone.add.value",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "delete-confirm-footer" },
                                  [
                                    _c(
                                      "el-button",
                                      { on: { click: _vm.addMilestoneCancel } },
                                      [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "wl-green",
                                        on: { click: _vm.commitAddMilestone },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.confirmationOn,
                  expression: "confirmationOn",
                },
              ],
              attrs: { name: "5" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "blue-border-title disable_select",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("general_tile_confirmation")) +
                      "\n            "
                  ),
                ]
              ),
              _c("div", { staticClass: "collapse-container" }, [
                _c("div", { staticClass: "switches-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("if_show_confirmation_reply_status")) +
                      "\n                "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "switch" },
                  [
                    _c("el-switch", {
                      attrs: {
                        size: "mini",
                        "active-text": _vm.$t("COMMON_YES"),
                        "inactive-text": _vm.$t("COMMON_NO"),
                      },
                      on: { change: _vm.onConfirmationReplyChange },
                      model: {
                        value: _vm.showConfirmationReply,
                        callback: function ($$v) {
                          _vm.showConfirmationReply = $$v
                        },
                        expression: "showConfirmationReply",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.groupAuditOn,
                  expression: "groupAuditOn",
                },
              ],
              attrs: { name: "2" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "blue-border-title disable_select",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("config_group_audit_title")) +
                      "\n            "
                  ),
                ]
              ),
              _c("div", { staticClass: "collapse-container" }, [
                _c("div", { staticClass: "switches-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("allow_component_down_upload")) +
                      "\n                "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "switch" },
                  [
                    _c("el-switch", {
                      attrs: {
                        size: "mini",
                        "active-text": _vm.$t("COMMON_YES"),
                        "inactive-text": _vm.$t("COMMON_NO"),
                        "active-value": 1,
                        "inactive-value": 0,
                      },
                      on: { change: _vm.onComponentDownloadChange },
                      model: {
                        value: _vm.componentDownload,
                        callback: function ($$v) {
                          _vm.componentDownload = $$v
                        },
                        expression: "componentDownload",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }